import React from 'react';
import { useUrlLocalizer } from 'tradera-lang/translate';
import { CombinedShippingBadge } from './combined-shipping-badge';

const CombinedShippingBadgeLink = ({ ...props }) => {
    const { toLocalizedUrl } = useUrlLocalizer();
    return (
        <a
            href={toLocalizedUrl('/frakt/samfrakt')}
            className="text-decoration-none"
            target="_blank"
            rel="noreferrer">
            <CombinedShippingBadge {...props} />
        </a>
    );
};

export default CombinedShippingBadgeLink;
